import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {AppEnviroment } from './model/app-enviroment';

import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(private router: Router,    
    private translate: TranslateService, private appEnviroment: AppEnviroment) { 
      AppEnviroment.Translate = translate;
      AppEnviroment.Translate.addLangs(['en', 'es']);
      AppEnviroment.Translate.setDefaultLang('es');
      AppEnviroment.Translate.use('es');
    }

  ngOnInit() {    
    AppEnviroment.LoadConfiguration();    
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }
}
